import * as axios from './Axios'

const PREFIX = 'language'

export const _list = () => axios.get(`${PREFIX}/list`)

// /**
//  * @param {Object} agent
//  * @return {Promise} mixed Promise
//  */

// export const _list = () => http.post(`${PREFIX}/List`)

// /**
//  * @param {Object} agent
//  * @return {Promise} mixed Promise
//  */
// export const _save = agent => http.post(`${PREFIX}/Save`, agent)

// /**
//  * @param {Object} agent
//  * @return {Promise} mixed Promise
//  */
// export const _delete = agent => http.post(`${PREFIX}/Delete`, agent)

// export const _searchCall = query => http.get(`${PREFIX}/search/${query}`)
